import { ChevronDown } from 'lucide-react';
import type { ContestWeekOption } from '../../utils/lobbyMyGamesDailyRevealContest';

type Props = {
  items: ContestWeekOption[];
  selectedId: string;
  onSelect: (id: string) => void;
  /** Accessible name, e.g. "Big League Draw contest week". */
  ariaLabel: string;
};

/**
 * Contest-week picker for My Games Recent, shown when a Daily Reveal product filter chip
 * is selected.
 *
 * Same date-range labels as Daily Reveal's ContestSelector pills, but as a single
 * dropdown — a horizontal pill strip would fight the game-type filter chips above. Native `<select>` keeps the Meadows webview's
 * OS picker on mobile.
 */
export default function DailyRevealContestWeekSelect({
  items,
  selectedId,
  onSelect,
  ariaLabel,
}: Props) {
  if (items.length === 0) return null;

  return (
    <div className="relative mb-3 inline-flex max-w-full">
      <select
        aria-label={ariaLabel}
        value={selectedId}
        onChange={e => onSelect(e.target.value)}
        disabled={items.length === 1}
        className={[
          'max-w-full appearance-none truncate rounded-full border border-white/60 bg-white/10 py-2 pl-4 pr-9',
          'text-[12px] font-semibold text-white outline-none transition-colors',
          'focus-visible:ring-2 focus-visible:ring-white/40',
          items.length === 1 ? 'cursor-default opacity-90' : 'cursor-pointer hover:bg-white/15',
        ].join(' ')}
        style={{ fontFamily: 'Inter, sans-serif' }}
      >
        {items.map(item => (
          <option key={item.id} value={item.id} className="bg-[#1a1a1a] text-white">
            {item.label}
          </option>
        ))}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute right-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-white/70"
      />
    </div>
  );
}
